import React from "react";
import classNames from "classnames";
import ContentEditorComponent from "@components/ContentEditorView/ContentEditorComponent";

const Medium = (props) => {
  const mediumClass = classNames({
    [`u-text-align-${props.align}`]: props.align && props.align !== "left",
    "u-border-b-dotted": props.borderBottom,
    "u-border-t-dotted": props.borderTop,
    "u-space-mb-10 u-space-mt-10": props.verticalMargin,
    "u-space-pt-10 u-space-pb-10": props.verticalPadding,
    "u-space-p-10": props.fullPadding,
    "Content-children-inherit": props.color,
  });

  const mediumStyles = {
    backgroundColor:
      props.bgColor && props.bgColor.length > 0 ? props.bgColor : null,
    color: props.color && props.color.length > 0 ? props.color : null,
  };

  const createMarkup = (content) => ({ __html: content });

  return (
    <div className={mediumClass} style={mediumStyles}>
      {props.html && (
        <div
          className="Cms"
          dangerouslySetInnerHTML={createMarkup(props.html)}
        />
      )}
      {props.children && <ContentEditorComponent content={props.children} />}
    </div>
  );
};

export default Medium;
